var _rect, _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "url(#paint0_linear_1624_48468)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 10.75V25C24 26.6569 22.6569 28 21 28H9C7.34315 28 6 26.6569 6 25V7C6 5.34314 7.34315 4 9 4H17.25L24 10.75ZM19.5 10.75C18.2574 10.75 17.25 9.74264 17.25 8.5V5.5H9C8.17157 5.5 7.5 6.17157 7.5 7V25C7.5 25.8284 8.17157 26.5 9 26.5H21C21.8284 26.5 22.5 25.8284 22.5 25V10.75H19.5Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.1875V25.25C25 26.7688 23.7315 28 22.1667 28H10.8333C9.26853 28 8 26.7688 8 25.25V8.75C8 7.23122 9.26853 6 10.8333 6H18.625L25 12.1875ZM20.75 12.1875C19.5764 12.1875 18.625 11.2641 18.625 10.125V7.375H10.8333C10.0509 7.375 9.41667 7.99061 9.41667 8.75V25.25C9.41667 26.0094 10.0509 26.625 10.8333 26.625H22.1667C22.9491 26.625 23.5833 26.0094 23.5833 25.25V12.1875H20.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5691 20.7579L15.489 15H16.3315L16.1657 16.1451L14.2113 22H13.3895L13.5691 20.7579ZM12.2776 15L13.9144 20.8226L14.0318 22H13.1685L11 15H12.2776ZM18.1685 20.7773L19.7293 15H21L18.8315 22H17.9751L18.1685 20.7773ZM16.518 15L18.3964 20.6608L18.6105 22H17.7956L15.7859 16.1322L15.6202 15H16.518Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1624_48468",
    x1: 0,
    y1: 0,
    x2: 32.0449,
    y2: 0.0450633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5296D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B58CA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/WORD.3b87393671a68a8f299f4f26dd0b8968.svg";
export { ForwardRef as ReactComponent };